import ReactPopover from "react-popover";
import styled from "styled-components";

export const TooltipWrapper = styled(ReactPopover)`
  min-width: max-content;
  z-index: 3;

  .Popover-tipShape {
    fill: ${({ theme }) => theme.surfaceElevated};
  }
`;

export const TooltipBody = styled.div`
  filter: drop-shadow(0 1px 8px ${({ theme }) => theme.shadowColor});
  font-size: 12px;
  padding: 12px;
  line-height: 18px;
  text-align: left;
  color: ${({ theme }) => theme.elevatedText};
  background-color: ${({ theme }) => theme.surfaceElevated};
  max-height: 90vh;
  max-width: 90vw;
`;
